import { memo } from "react";
import { useSelector } from "react-redux";
import ChatComposer from "../../components/ChatComposer";
import ChatMessageList from "../../components/ChatMessageList";
import { sendChatMessage } from "../../infrastructure/send-chat-message";
import "../../chat.css";

/** Shared conversation view for admin chat and the existing booth dialog. */
function ChatRoom({ converstions = [], loading2 = false, currentUserId,
  socket, id, boothId, setMessage, connected = Boolean(socket), onSend, composerIdentity }) {
  const scheme = useSelector((state) => state.themeColor?.themeColor || "light");
  return <section className="dk-chat-room dk-chat-theme" data-color-scheme={scheme}>
    <ChatMessageList key={`history-${id || boothId || "empty"}`} messages={converstions} currentUserId={currentUserId} loading={loading2} />
    <ChatComposer key={composerIdentity || `composer-${id || boothId || "empty"}`} disabled={!connected || loading2 || (!id && !boothId)}
      onDraftChange={boothId && !id ? setMessage : undefined}
      onSend={onSend || ((text) => sendChatMessage(socket, { id, boothId, text, currentUserId,
        beforeId: converstions.reduce((maximum, message) => Math.max(maximum, Number(message.id) || 0), 0) }))} />
  </section>;
}

export default memo(ChatRoom);
